
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collateral-loans",
      function () {
        return require("private-next-pages/collateral-loans.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collateral-loans"])
      });
    }
  